import { array, bool, InferType, mixed, number, object, ObjectSchema, string } from 'yup';

import { DynamicCardActionSchema } from './actions/actions.yup';
import { OfferOverridesSchema } from './overrides/overrides.yup';
import { IneligibleIfMembershipHasRewardConstraintSchema } from './constraints/constraint.yup';
import { DynamicCardConstraint, DynamicCardCustomData, DynamicCardCustomDataVersion } from './custom-data.types';

export const ConstraintSchema = mixed<InferType<typeof IneligibleIfMembershipHasRewardConstraintSchema>>()
  .test(
    'dynamic-card-constraint',
    'Includes invalid constraint descriptors',
    (value: unknown): value is DynamicCardConstraint => {
      return !!IneligibleIfMembershipHasRewardConstraintSchema.isValidSync(value);
    },
  )
  .required()
  .strict();

export const DynamicCardCustomDataSchema: ObjectSchema<DynamicCardCustomData> = object({
  // .min(1).max(1) is a hack needed for type checking
  version: number<DynamicCardCustomDataVersion>().required().strict().min(1).max(1),
  rank: number().strict().optional(),
  href: string().optional(),
  action: DynamicCardActionSchema.optional(),
  overrides: OfferOverridesSchema.optional(),
  constraints: array().of(ConstraintSchema).optional(),
  __debug: bool().strict().optional(),
  // R TODO: get rid of this or move to a better schema
  completeProfileRestricted: bool().strict().optional(),
  // R TODO: get rid of Delek Hack
  showMemberPointsAsEntries: bool().strict().optional(),
}).strict();
